<template>
  <transition name="fade" appear>
    <div class="transition-generic w-full wrapper-lg">
      <campanha-icone class="big-white" :canal="$route.params.canal" />
      <h4 class="m-t-md">Para qual lista devemos enviar?</h4>
      <div class="m-t-lg">
        <m-radio name="tipoLista" label="Todas as pessoas registradas" val="todos" v-model="tipoLista" />
        <div class="wrapper m-t-n">
          <m-checkbox :value="1" v-model="tipoPessoa" label="Pessoas" />
          <m-checkbox :value="2" v-model="tipoPessoa" label="Empresas" />
          <m-checkbox :value="3" v-model="tipoPessoa" label="Arrematantes" />
          <m-checkbox :value="4" v-model="tipoPessoa" label="Comitentes" />
          <m-checkbox :value="5" v-model="tipoPessoa" label="Colaboradores" />
        </div>

        <m-radio disabled name="tipoLista" label="Para uma lista" val="lista" v-model="tipoLista" />
        <m-radio disabled name="tipoLista" label="Para um ou mais segmentos" val="segmento" v-model="tipoLista" />
        <m-radio disabled name="tipoLista" label="Para participantes de uma pesquisa" val="pesquisa" v-model="tipoLista" />
      </div>
      <div class="m-t" style="max-width: 500px">
        Fique tranquilo, ainda vamos fazer uma verificação para você saber quem desta lista selecionada não preenche os requisitos mínimos para se comunicar por este canal.
      </div>
    </div>
  </transition>
</template>

<script>
import CampanhaIcone from "@/components/marketing/components/CampanhaIcone"
import MCheckbox from "@/components/marketing/components/inputs/Checkbox"
import MRadio from "@/components/marketing/components/inputs/Radio"
export default {
  name: "Destinatarios",
  components: {MRadio, MCheckbox, CampanhaIcone},
  data() {
    return {
      tipoLista: 'todos',
      tipoPessoa: [1, 2]
    }
  },
  watch: {
    tipoPessoa (v) {
      this.$nextTick(() => {
        let n = false
        this.tipoPessoa.map(t => {
          if (t > 2) {
            n = true
          }
        })
        if (n) {
          this.tipoPessoa.indexOf(1) !== -1 && this.tipoPessoa.splice(this.tipoPessoa.indexOf(1), 1)
          this.tipoPessoa.indexOf(2) !== -1 && this.tipoPessoa.splice(this.tipoPessoa.indexOf(2), 1)
        }
      })
    }
  }
}
</script>
